import React from 'react';
import { Box, Typography, Button, IconButton } from '@/ui';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  expanded: boolean | undefined;
  onToggle: () => void;
  onEdit: () => void;
  editStartIcon?: React.ReactNode;
  expandIcon?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  icon,
  title,
  subtitle,
  expanded,
  onToggle,
  onEdit,
  editStartIcon,
  expandIcon
}) => {
  const sectionKey = title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  return (
    <Box data-testid={`pages-private-dashboard-budget-page-com-section-header-container-action-1-${sectionKey}`}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: expanded ? 3 : 0,
        py: 2
      }}
    >
      <Box data-testid={`pages-private-dashboard-budget-page-com-section-header-container-on-toggle-${sectionKey}`} 
        onClick={onToggle}
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2, 
          flex: 1,
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            '& .section-title': {
              color: '#00A991'
            }
          }
        }}
      >
        <Box data-testid={`pages-private-dashboard-budget-page-com-section-header-container-action-2-${sectionKey}`}
          sx={{
            width: 40,
            height: 40,
            borderRadius: '8px',
            backgroundColor: '#F1F5F9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {icon}
        </Box>
        <Box data-testid={`pages-private-dashboard-budget-page-com-section-header-container-action-3-${sectionKey}`} sx={{ flex: 1 }}>
          <Typography data-testid={`pages-private-dashboard-budget-page-com-section-header-text-action-1-${sectionKey}`}
            variant="h6"
            className="section-title"
            sx={{
              fontSize: '18px',
              fontWeight: 700,
              color: '#1E293B',
              mb: 0.5,
              transition: 'color 0.2s ease'
            }}
          >
            {title}
          </Typography>
          <Typography data-testid={`pages-private-dashboard-budget-page-com-section-header-text-action-2-${sectionKey}`}
            variant="body2"
            sx={{
              fontSize: '13px',
              color: '#64748B'
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Box data-testid={`pages-private-dashboard-budget-page-com-section-header-container-action-4-${sectionKey}`} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Button data-testid={`pages-private-dashboard-budget-page-com-section-header-btn-on-edit-${sectionKey}`}
          variant="contained"
          startIcon={editStartIcon}
          onClick={onEdit}
          sx={{
            backgroundColor: '#004D44',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 600,
            px: 2.5,
            py: 0.75,
            borderRadius: '6px',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#004D44',
              boxShadow: 'none',
              border: '0.5px solid #004D44'
            }
          }}
        >
          Edit
        </Button>
        <IconButton data-testid={`pages-private-dashboard-budget-page-com-section-header-btn-on-toggle-${sectionKey}`}
          onClick={onToggle}
          sx={{
            color: '#64748B',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s'
          }}
        >
          {expandIcon}
        </IconButton>
      </Box>
    </Box>
  );
};

export default SectionHeader;


